import styled from 'styled-components';
import { TextStyles } from './Text';
const Heading5 = /*#__PURE__*/styled.h5.withConfig({
  displayName: "Heading5",
  componentId: "sc-1u7yfs2-0"
})(["font-size:16px;", ""], TextStyles);
/** @component */

export default Heading5;